'use strict';

import StoreHours from '../storeLocator/storeHours';

module.exports = {
    initStoreHours: function () {
        StoreHours.run();
    },

    loadMoreStores: function () {
        $('body').on('click', '.js-load-store-results', function (e) {
            e.preventDefault();

            var url = $(e.currentTarget).data('url');
            $.spinner().start();
            $.ajax(url).then(function (data) {
                $('.js-more-store-list-container').html(data);
                StoreHours.run();
                $('.js-load-store-results-container').addClass('hidden');
                $.spinner().stop();
            });
        });
    }
};
